/*
 * These are the variables that determine what our central data store (`../reducers/index.js`)
 * changes in our state.
 */

export const CHANGE_FORM = 'CHANGE_FORM';
export const SET_AUTH = 'SET_AUTH';
export const SENDING_REQUEST = 'SENDING_REQUEST';
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const CHANGE_FORM_REGISTER = 'CHANGE_FORM_REGISTER';
export const LOGOUT = 'LOGOUT';
export const REQUEST_ERROR = 'REQUEST_ERROR';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const SHOW_PROGRESS_BAR = 'SHOW_PROGRESS_BAR';
export const HIDE_PROGRESS_BAR = 'HIDE_PROGRESS_BAR';
export const CHANGE_FORM_BUSINESS = 'CHANGE_FORM_BUSINESS';
export const BUSINESS_TYPES_REQUEST = 'BUSINESS_TYPES_REQUEST';
export const CHANGE_BUSINESS_TYPES_DATA = 'CHANGE_BUSINESS_TYPES_DATA';
export const BUSINESS_CATEGORIES_REQUEST = 'BUSINESS_CATEGORIES_REQUEST';
export const CHANGE_BUSINESS_CATEGORIES_DATA =
  'CHANGE_BUSINESS_CATEGORIES_DATA';
export const CHANGE_BUSINESS_CATEGORIES_ALL_DATA =
  'CHANGE_BUSINESS_CATEGORIES_ALL_DATA';
export const CHANGE_BUSINESS_STARTS_DATA = 'CHANGE_BUSINESS_STARTS_DATA';
export const CHANGE_BUSINESS_LOCATIONS_DATA = 'CHANGE_BUSINESS_LOCATIONS_DATA';
export const CHANGE_BUSINESS_PROVINCE_DATA = 'CHANGE_BUSINESS_PROVINCE_DATA';
export const CHANGE_BUSINESS_CITY_DATA = 'CHANGE_BUSINESS_CITY_DATA';
export const CHANGE_BUSINESS_ZIPCODE_DATA = 'CHANGE_BUSINESS_ZIPCODE_DATA';
export const CHANGE_BUSINESS_KECAMATAN_DATA = 'CHANGE_BUSINESS_KECAMATAN_DATA';
export const CHANGE_BANK_LIST_DATA = 'CHANGE_BANK_LIST_DATA';
export const CHANGE_BUSINESS_SALES_DATA = 'CHANGE_BUSINESS_SALES_DATA';
export const BUSINESS_CATEGORIES_ALL_REQUEST =
  'BUSINESS_CATEGORIES_ALL_REQUEST';
export const BUSINESS_STARTS_REQUEST = 'BUSINESS_STARTS_REQUEST';
export const BUSINESS_LOCATIONS_REQUEST = 'BUSINESS_LOCATIONS_REQUEST';
export const BUSINESS_PROVINCE_REQUEST = 'BUSINESS_PROVINCE_REQUEST';
export const BUSINESS_CITY_REQUEST = 'BUSINESS_CITY_REQUEST';
export const BUSINESS_ZIPCODE_REQUEST = 'BUSINESS_ZIPCODE_REQUEST';
export const GET_DROPDOWN_REQUEST = 'GET_DROPDOWN_REQUEST';
export const BUSINESS_KECAMATAN_REQUEST = 'BUSINESS_KECAMATAN_REQUEST';
export const BANK_LIST_REQUEST = 'BANK_LIST_REQUEST';
export const BUSINESS_SALES_REQUEST = 'BUSINESS_SALES_REQUEST';
export const SET_AUTH_FROM_LOCAL = 'SET_AUTH_FROM_LOCAL';
export const SET_AUTH_FROM_API = 'SET_AUTH_FROM_API';
export const SET_PERMISSIONS = 'SET_PERMISSIONS';
export const RESEND_VERIFICATION_EMAIL = 'RESEND_VERIFICATION_EMAIL';
export const GET_DASHBOARD = 'dashboard/GET_DASHBOARD';
export const SET_DASHBOARD = 'SET_DASHBOARD';
export const GET_FILTERED_DATE = 'GET_FILTERED_DATE';
export const REDIRECT_TO = 'REDIRECT_TO';
export const LOAD_RESET_PASSWORD = 'LOAD_RESET_PASSWORD';
export const CHANGE_FORM_RESET_PASSWORD = 'CHANGE_FORM_RESET_PASSWORD';
export const SEND_RESET_PASSWORD = 'SEND_RESET_PASSWORD';
export const LOAD_PREPARE_ENCRYPTION = 'LOAD_PREPARE_ENCRYPTION';
export const SET_PREPARE_ENCRYPTION = 'SET_PREPARE_ENCRYPTION';
export const SET_PROFILE = 'SET_PROFILE';
export const GET_PROFILE_REQUEST = 'GET_PROFILE_REQUEST';
export const CLEAR_REGISTER_FORM = 'CLEAR_REGISTER_FORM';
export const SHOW_LOADING_SPINNER = 'SHOW_LOADING_SPINNER';
export const SET_IS_REGISTERED = 'SET_IS_REGISTERED';
export const SET_RESEND_VERIFICATION_EMAIL_STATE =
  'SET_RESEND_VERIFICATION_EMAIL_STATE';
export const TO_LOGIN_PAGE = 'TO_LOGIN_PAGE';
export const DASHBOARD_SHOW_MODAL_OUTLET_MOBILE =
  'DASHBOARD_SHOW_MODAL_OUTLET_MOBILE';
export const SET_EXTERNAL_REDIRECT_URL = 'SET_EXTERNAL_REDIRECT_URL';
export const SHOW_ACTIVE_APPLICATIONS = 'SHOW_ACTIVE_APPLICATIONS';
export const BUSINESS_OPENINGS_REQUEST = 'BUSINESS_OPENINGS_REQUEST';
export const CHANGE_BUSINESS_OPENINGS = 'CHANGE_BUSINESS_OPENINGS';
export const SET_BUSINESS_INFO_DATA = 'SET_BUSINESS_INFO_DATA';
export const BUSINESS_INFO_DATA_REQUEST = 'BUSINESS_INFO_DATA_REQUEST';
export const CHECK_KOINWORKS_STATUS = 'CHECK_KOINWORKS_STATUS';
export const BUSINESS_NUMBER_OF_OUTLETS_REQUEST =
  'BUSINESS_NUMBER_OF_OUTLETS_REQUEST';
export const BUSINESS_NUMBER_OF_OUTLETS_DATA =
  'BUSINESS_NUMBER_OF_OUTLETS_DATA';
export const BUSINESS_CITIES_ALL_REQUEST = 'BUSINESS_CITIES_ALL_REQUEST';
export const BUSINESS_CITIES_ALL_DATA = 'BUSINESS_CITIES_ALL_DATA';
export const BUSINESS_CITIES_POPULAR_REQUEST =
  'BUSINESS_CITIES_POPULAR_REQUEST';
export const BUSINESS_CITIES_POPULAR_DATA = 'BUSINESS_CITIES_POPULAR_DATA';
